// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "./Header.css";
// import logo from "../assets/logo3.svg";

// function Header() {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => setIsOpen(!isOpen);

//   return (
//     <header className="top-nav col-md-12">
//       <div className="col-md-4 log">
//         <div className="logo">
//           <img src={logo} alt="Southin Cafe Logo" />
//         </div>
//         <button className="toggle-btn" onClick={toggleMenu}>
//           ☰
//         </button>
//       </div>

//       <div className={`col-md-8 head-1 ${isOpen ? "show-nav" : ""}`}>
//         <nav className="nav-links menu">
//           <Link to="/" className="menu-item" onClick={() => setIsOpen(false)}>
//             Home
//           </Link>
//           <Link
//             to="/privacy-policy"
//             className="menu-item"
//             onClick={() => setIsOpen(false)}
//           >
//             Privacy Policy
//           </Link>
//           <Link
//             to="/terms-and-conditions"
//             className="menu-item"
//             onClick={() => setIsOpen(false)}
//           >
//             Terms & Conditions
//           </Link>
//           <Link
//             to="/cancellation-and-refund"
//             className="menu-item"
//             onClick={() => setIsOpen(false)}
//           >
//             Cancellation & Refund
//           </Link>
//           <Link
//             to="/contact-us"
//             className="menu-item"
//             onClick={() => setIsOpen(false)}
//           >
//             Contact Us
//           </Link>
//         </nav>
//       </div>
//     </header>
//   );
// }

// export default Header;
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../assets/logo3.svg";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="top-nav col-md-12">
      <div className="col-md-3 log">
        <div className="logo">
          <img src={logo} alt="Southin Cafe Logo" />
        </div>
        <button className="toggle-btn" onClick={toggleMenu}>
          {isOpen ? "✕" : "☰"}
        </button>
      </div>

      <div className={`col-md-9 head-1 ${isOpen ? "open-sidebar" : ""}`}>
        <nav className="nav-links menu">
          <Link to="/" className="menu-item" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/privacy-policy" className="menu-item" onClick={closeMenu}>
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className="menu-item" onClick={closeMenu}>
            Cookie Policy
          </Link>
          <Link
            to="/terms-and-conditions"
            className="menu-item"
            onClick={closeMenu}
          >
            Terms & Conditions
          </Link>
          <Link
            to="/cancellation-and-refund"
            className="menu-item"
            onClick={closeMenu}
          >
            Cancellation & Refund
          </Link>
          <Link to="/contact-us" className="menu-item" onClick={closeMenu}>
            Contact Us
          </Link>
          <Link to="/account-delete" className="menu-item" onClick={closeMenu}>
            Account Delete
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
